import { render, staticRenderFns } from "./QuotePartsControlOrdered.vue?vue&type=template&id=53de314b&scoped=true"
import script from "./QuotePartsControlOrdered.vue?vue&type=script&lang=js"
export * from "./QuotePartsControlOrdered.vue?vue&type=script&lang=js"
import style0 from "./QuotePartsControlOrdered.vue?vue&type=style&index=0&id=53de314b&lang=scss&scoped=true"
import style1 from "./QuotePartsControlOrdered.vue?vue&type=style&index=1&id=53de314b&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de314b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53de314b')) {
      api.createRecord('53de314b', component.options)
    } else {
      api.reload('53de314b', component.options)
    }
    module.hot.accept("./QuotePartsControlOrdered.vue?vue&type=template&id=53de314b&scoped=true", function () {
      api.rerender('53de314b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/partsControl/orderedParts/QuotePartsControlOrdered.vue"
export default component.exports